import React, { useMemo } from "react";
import { isNumber } from "lodash";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
import formatNumber from "../../../../../../../../../../utils/formatNumber";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (item: CashAmountCellContent.Props["item"]) => {
	if (!isNumber(item?.ordersCounters?.cash?.amount)) return "";
	return formatNumber(item?.ordersCounters?.cash?.amount);
};

const CashAmountCellContent: React.FC<CashAmountCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace CashAmountCellContent {
	interface Props {
		item: ExecutorReport.Model;
	}
}

export default CashAmountCellContent;
